<template>
  <!-- Page content -->
  <div id="main-default" class="container-fluid" style="padding:0px !important">
    <div class="card col-xl-12">
      <div class="row">
        <!-- <div class="col-md-6 row mt-3"  v-if="userType == '2' || userType == '3'">
              <div class="col-xl-12">
              <h1 class="page-title mt-2">
                {{ $t('title.overtimeList') }}
              </h1>
              </div>
 
            <div class="col-xs-12 col-md-6 my-2">
                <treeselect v-model="departmentid" :multiple="false" 
                :options="departmentOption" :default-expand-level="Infinity"
                @input="changeDepartment"
                :noChildrenText="$t('label.noNodeChildren')" :placeholder="$t('label.chooseDepartment')" />
              </div>
              <div class="col-xs-12 col-md-6 my-2">
                <treeselect v-model="shiftid" :multiple="false" :options="shiftOption" :flat="false"
                          :default-expand-level="1" :placeholder="$t('label.filterByuser')" 
                          @input="changeDepartment"
                       /> 
                
              </div>
            <div class="col-xs-6 col-md-6">
                    <b-form-input v-model="aliasId" :placeholder=" $t('label.employeeCode')" @input="changeDepartment" type="text">
                    </b-form-input>
            </div>
            <div class="col-xs-6 col-md-6">
              <b-form-group>
                <div class="autocomplete" v-click-outside="handleClickOutside">
                  <b-form-input v-model="fullName" @input="onChangeName" type="text" :placeholder=" $t('label.fullName')">
                  </b-form-input>
                  <ul v-show="isOpenNameRes" class="autocomplete-results">
                    <li v-for="(result, i) in nameResults" :key="i" @click="setNameResult(result)"
                      class="autocomplete-result">
                      {{ result.value }} - {{ result.text }}
                    </li>
                  </ul>
                </div>
              </b-form-group>
            </div>

          </div> -->
        <div class="col-md-6 row mt-0">
          <div class="col-xl-12">
            <h1 class="page-title">
              {{ $t('title.overtimeList') }}
            </h1>
          </div>
          <div class="col-xs-12 col-md-6">
            <treeselect v-model="departmentid" :multiple="false" :options="departmentOption"
              :default-expand-level="Infinity" @input="changeDepartment" :noChildrenText="$t('label.noNodeChildren')"
              :placeholder="$t('label.chooseDepartment')" />
          </div>
          <div class="col-xs-12 col-md-6">
            <b-form-group>
              <flat-pickr v-model="dateSelectSearch" :config="configDateTimePickerSearch"
                :placeholder="$t('label.chooseDate')" name="reportDate" class="form-control"
                @input="getListOverTime()"></flat-pickr>
              <div class="error-message w-100 clear text-left">
                {{ msg["offWorkFrom"] ? $t(msg["offWorkFrom"]) : "" }}
              </div>
            </b-form-group>
          </div>
          <div class="col-xs-6 col-md-6">
            <b-form-input v-model="aliasId" :placeholder="$t('label.employeeCode')" @input="changeDepartment"
              type="text">
            </b-form-input>
          </div>
          <div class="col-xs-6 col-md-6 pb-2">
            <b-form-group>
              <div class="autocomplete" v-click-outside="handleClickOutside">
                <b-form-input v-model="fullName" @input="onChangeName" type="text" :placeholder="$t('label.fullName')">
                </b-form-input>
                <ul v-show="isOpenNameRes" class="autocomplete-results">
                  <li v-for="(result, i) in nameResults" :key="i" @click="setNameResult(result)"
                    class="autocomplete-result">
                    {{ result.value }} - {{ result.text }}
                  </li>
                </ul>
              </div>
            </b-form-group>
          </div>

        </div>
        <div class="col-md-6 mt-3 pt-2">
          <h3 class="mt-1">Thêm mới đơn tăng ca</h3>

          <div class="row align-items-center justify-content-center">
            <!-- <div class="col-md-4 col-xs-12">
                <label>Loại đơn</label>
                <treeselect v-model="shiftsId" :multiple="false" :options="shiftsOptions" :flat="false"
                          :default-expand-level="1" :placeholder="$t('label.chooseShift')" 
                          />
              </div> -->
            <div class="col-md-4 col-xs-12">
              <label>{{ $t('label.chooseDate') }}</label>
              <flat-pickr v-model="startDateString" :config="configDateTimePicker" name="birthdate"
                :placeholder="$t('label.startTime')" class="form-control"></flat-pickr>
            </div>
            <div class="col-md-4 col-xs-12">
              <label>{{ $t('label.startTime') }}</label>
              <flat-pickr v-model="startTimeAdd" :config="configTimePicker" name="birthdate"
                :placeholder="$t('label.startTime')" class="form-control"></flat-pickr>
            </div>
            <div class="col-md-4 col-xs-12">
              <label>{{ $t('label.endTime') }}</label>
              <flat-pickr v-model="endTimeAdd" :config="configTimePicker" name="birthdate" class="form-control"
                :placeholder="$t('label.endTime')"></flat-pickr>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12 pt-3">
              <!-- <b-form-group class="required-mess" id="input-group-2" :label="$t('label.reasonForOT')"> -->
              <b-form-group class="" id="input-group-2" :label="$t('label.reasonForOT')">
                <textarea class="form-control form-control-sm" id="tar-2" :placeholder="$t('label.reasonForOT')"
                  required v-model="reasonForOTAdd" rows="3"></textarea>
                <div class="error-message w-100 clear text-left">
                  {{ msg["reason"] ? $t(msg["reason"]) : "" }}
                </div>
              </b-form-group>
            </div>
            <div class="col-md-12 col-xs-12 mt-2">
              <div class="">
                <div class="text-right">
                  <a href="javascript:void(0)" class="btn btn-danger bg-gradient-danger"
                    @click="addOvertime()"><font-awesome-icon icon="plus" /> {{ $t("label.addNew") }}</a>
                  <!-- <button class="btn btn-success bg-gradient-success btn-block" @click="addOvertime()">Thêm mới ca</button> -->
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class=" col-xs-12 col-md-6">
          <div class="card">
            <div class="card-body m-0 p-0 table-responsive">
              <h2 class="ml-2">Danh sách nhân sự</h2>
              <b-table bordered="bordered" style="max-height: 500px;" class=" default-table" hover :items="dataTable"
                :fields="fields" responsive id="table-staff" @row-clicked="rowClickHandler"
                @head-clicked="handleHeaderClick($event)">
                <template #head(checkbox)="data">
                  <b-form-checkbox @click.native.stop @change="selectAll(data)" v-model="allSelected">
                  </b-form-checkbox>
                </template>
                <template #cell(checkbox)="data">
                  <b-form-checkbox @click.native.stop :value="data.item.aliasID" v-model="userSelected">
                  </b-form-checkbox>
                </template>
              </b-table>
              <b-pagination v-model="currentPage" :total-rows="totalRecord" :per-page="perPage" align="right" size="sm"
                class="m-4" aria-controls="table-staff" v-on:click.native="getEmployee()"></b-pagination>
            </div>
          </div>
        </div>
        <div class=" col-xs-12 col-md-6">
          <div class="card">
            <div class="card-body m-0 p-0 table-responsive">
              <h2 class="ml-2">Danh sách đơn tăng ca {{ nameEmployee }}</h2>
              <b-table bordered="bordered" style="max-height: 500px;" class="default-table" hover
                :items="dataTableOverTime" :fields="fieldsHisotry" responsive :current-page="currentPageOverTime"
                :per-page="perPage" id="table-OverTime" show-empty empty-text="Không có dữ liệu"
                @head-clicked="handleHeaderClickDetails($event)">
                <template #cell(reason)="data">
                  <div class="m-0">
                    {{ data.item.reason }}
                  </div>
                  <small class="text-danger">{{ $t("label.timeDay") }}:
                    {{ data.item.dateOT }}
                  </small>
                </template>
                <template #cell(time)="data">
                  <div class="m-0">
                    {{ data.item.startTime }} - {{ data.item.endTime }}
                  </div>
                  <small class="text-danger">({{ data.item.minute_ot }} {{ $t("label.minute") }})</small> 
                </template>
                <template #cell(button)="data" v-if="checkPermission(13)">
                  <button class="btn btn-primary btn-sm" @click="showInfoDetail(data.item)" v-b-tooltip.hover
                    :title="$t('label.edit')">
                    <font-awesome-icon icon="edit" />
                  </button>
                  <button class="btn btn-danger btn-sm" @click="showDelete(data.item.id)" v-b-tooltip.hover
                    :title="$t('label.delete')">
                    <font-awesome-icon icon="trash" />
                  </button>
                </template>
                <template #empty="scope">
                  {{ $t("notify.message.nodata") }}
                </template>
              </b-table>
              <b-pagination v-model="currentPageOverTime" :total-rows="totalRecordOT" :per-page="perPageOverTime"
                align="right" size="sm" class="m-4" aria-controls="table-OverTime"
                v-on:click.native="getListOverTime(this.employeeId)"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="modalInfoDetail" ref="modal-info-detail" :title="$t('label.editOverTime')" hide-footer
      header-bg-variant="secondary" modal-class="modal-info-detail text-center" centered size="lg">
      <b-form ref="form" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12">
          <b-form-group id="input-group-1" class="required-mess" :label="$t('label.selectStaff')">
            <b-form-input disabled type="text" v-model="idPerson" min="0" max="200"></b-form-input>
            <div class="error-message w-100 clear text-left">
              {{ msg["userId"] ? $t(msg["userId"]) : "" }}
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-6 col-md-6 col-xs-12">
          <b-form-group id="input-group-1" class="required-mess" :label="$t('label.chooseDate')">
            <flat-pickr v-model="dateSelect" :config="configDateTimePicker" :placeholder="$t('label.chooseDate')"
              name="birthdate" class="form-control"></flat-pickr>
            <div class="error-message w-100 clear text-left">
              {{ msg["dateOvertime"] ? $t(msg["dateOvertime"]) : "" }}
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-6 col-md-3 col-xs-12">
          <b-form-group class="required-mess" :label="$t('label.startTime')">
            <flat-pickr v-model="startTime" :config="configTimePicker" :placeholder="$t('label.startTime')"
              name="reportDate" class="form-control"></flat-pickr>
            <div class="error-message w-100 clear text-left">
              {{ msg["dateOvertime"] ? $t(msg["dateOvertime"]) : "" }}
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-6 col-md-3 col-xs-12">
          <b-form-group class="required-mess" :label="$t('label.endTime')">
            <flat-pickr v-model="endTime" :config="configTimePicker" :placeholder="$t('label.endTime')"
              name="reportDate" class="form-control"></flat-pickr>
            <div class="error-message w-100 clear text-left">
              {{ msg["dateOvertime"] ? $t(msg["dateOvertime"]) : "" }}
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-6 col-md-6 col-xs-12">
          <b-form-group class="required-mess" :label="$t('label.minuteOvertime')">
            <b-form-input type="number" v-model="minuteOT" disabled min="0" max="200"></b-form-input>
            <div class="error-message w-100 clear text-left">
              {{ msg["minuteOvertime"] ? $t(msg["minuteOvertime"]) : "" }}
            </div>
          </b-form-group>
        </div>
        <!--   <div class="col-lg-6 col-md-6 col-xs-12">
          <b-form-group
            id="input-group-4"
            :label="$t('label.shift')"
            class="required-mess"
          >
            <select v-model="shiftId" class="form-control">
              <option v-for="shift in shifts" v-bind:value="shift.id">
                {{ shift.label }}
              </option>
            </select>
            <div class="error-message w-100 clear text-left">
              {{ msg["shiftId"] ? $t(msg["shiftId"]) : "" }}
            </div>
          </b-form-group>
        </div> -->
        <div class="col-lg-12 col-md-12 col-xs-12">
          <b-form-group class="required-mess" id="input-group-2" :label="$t('label.reasonForOT')">
            <textarea class="form-control form-control-sm" id="tar-2" :placeholder="$t('label.reasonForOT')" required
              v-model="reasonForOT" rows="3"></textarea>
            <div class="error-message w-100 clear text-left">
              {{ msg["reason"] ? $t(msg["reason"]) : "" }}
            </div>
          </b-form-group>
        </div>
        <!-- <div class="row col-12" v-for="(approval, i) in approveList" :key="i">
          <div class="col-12">
            <h3>{{ $t("label.approveStep") }} {{ i + 1 }}</h3>
          </div>
          <div class="col-6">
            <b-form-group :label="$t('label.jobPosition')">
              <treeselect v-model="approval.position" :multiple="false" :options="approval.positionOption"
                :default-expand-level="Infinity" @select="changePosition(i)"
                :noChildrenText="$t('label.noNodeChildren')" :placeholder="$t('label.choosePosition')" />
            </b-form-group>
          </div>
          <div class="col-6">
            <b-form-group :label="$t('label.approver')">
              <select class="form-control" v-model="approval.user">
                <option v-for="user in approval.listUser" v-bind:value="user.id">
                  {{ user.fullName }}
                </option>
              </select>
              <div class="error-message w-100 clear text-left">
                {{
                  msg["approveBy[" + i + "]"]
                    ? $t(msg["approveBy[" + i + "]"])
                    : ""
                }}
              </div>
            </b-form-group>
          </div>
        </div> -->
        <!-- <div class="col-12" >
          <b-button @click="addMoreApprove">{{
            $t("label.addApproveStep")
          }}</b-button> 
        </div>-->
      </b-form>
      <div class="d-block text-center">
        <div class="text-center">
          <b-button class="btn btn-danger" @click="editOvertime">{{ $t("label.save") }}
          </b-button>
          <b-button class="btn btn-default" @click="hideModalInfoDetail">{{ $t("label.cancel") }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="modalDelete" ref="modal-delete" hide-header hide-footer header-bg-variant="secondary"
      modal-class="modal-delete text-center" centered size="md">
      <div>
        <div class="modal-delete--warning">
          <div class="modal-delete--warning__content">!</div>
        </div>
        <div>
          <h2 class="text-warning">{{ $t("label.areYouSure") }}?</h2>
        </div>
        <div>{{ $t("label.sureOvertime") }}</div>
        <div class="mt-3">
          <b-button variant="primary" @click="deleteOvertime()">{{ $t("label.iAgree") }}
          </b-button>
          <b-button variant="secondary" @click="hideModalDelete">{{ $t("label.cancel") }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>

</template>
<script lang="js">
import apiClient from '@/axios'
import apiServer from '@/axiosServer'
import moment from 'moment'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import PulseLoader from '@/components/PulseLoader.vue'
import FlatpickrLanguages from "flatpickr/dist/l10n"
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { hasPermission } from '@/constants/permissions';

export default {
  components: { Treeselect, PulseLoader, flatPickr },
  data() {
    return {
      modalDelete: false,
      modalInfoDetail: false,
      userType: null,
      currentPageOverTime: 1,
      perPageOverTime: 25,
      loading: false,
      dataTable: [],
      perPage: 25,
      shiftsId: null,
      currentPage: 1,
      allSelected: false,
      totalRecord: 0,
      totalRecordOT: 0,
      nameEmployee: '',
      fields: [
        {
          label: "",
          key: "checkbox",
          class: "align-middle",
          sortable: false,
        },
        {
          label: this.$t('label.idEmployee'),
          key: 'aliasID',
          class: 'align-middle',
          sortable: false
        },
        {
          label: this.$t('label.fullName'),
          key: 'fullName',
          class: 'align-middle',
          sortable: false
        },
        {
          label: this.$t('label.jobPosition'),
          key: 'position',
          class: 'align-middle',
          sortable: false
        },
        {
          label: this.$t('label.department'),
          key: 'department',
          class: 'align-middle',
          sortable: false
        }
      ],
      userSelected: [],
      startDateString: '',
      endDateString: '',
      configDateTimePicker: {
        // minDate: "today",
        dateFormat: 'd/m/Y',
        time_24hr: true,
        locale: FlatpickrLanguages["en"],
        shorthandCurrentMonth: true

      },
      configDateTimePickerEnddate: {
        // enableTime: true,

        dateFormat: 'd/m/Y',
        time_24hr: true,
        locale: FlatpickrLanguages["vn"],
        shorthandCurrentMonth: true

      },
      configTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
      },
      dateSelectSearch: "",
      configDateTimePickerSearch: {
        dateFormat: "d/m/Y",
        locale: FlatpickrLanguages["vn"],
        shorthandCurrentMonth: true,
      },
      nameResults: [],
      fullName: null,
      isOpenNameRes: false,
      dataTableOverTime: [],
      fieldsHisotry: [
        {
          label: this.$t("label.idEmployee"),
          key: 'aliasID',
          class: 'align-middle',
          sortable: false
        },
        {
          label: this.$t('label.fullName'),
          key: "fullName",
          class: "align-middle",
          sortable: false,
        },
        {
          label: this.$t('label.department'),
          key: "departmentName",
          class: "align-middle",
          sortable: false,
        },
        {
          label: this.$t("label.reason"),
          key: "reason",
          class: "align-middle",
          sortable: false,
        },
        {
          label: this.$t("label.overtimeRegistrationTime"),
          key: "time",
          class: "align-middle",
          sortable: false,
        },
        {
          label: this.$t("label.control"),
          key: "button",
          tdClass: "text-center",
          class: "align-middle",
          thClass: "text-center",
        },
      ],
      departmentid: null,
      shiftid: null,
      aliasId: null,
      departmentOption: [],
      shiftOption: [{
        "id": null,
        "label": 'Tất cả'
      },
      {
        "id": 0,
        "label": 'Chưa có ca'
      },
      {
        "id": 1,
        "label": 'Đã có ca'
      }],
      shiftsOptions: [],
      employeeId: null,
      idDelete: null,
      idPerson: "",
      minuteOT: null,
      overtimeId: null,
      reasonForOT: "",
      reasonForOTAdd: "",
      startTime: null,
      msg: [],
      endTime: null,
      dateSelect: "",
      startTimeAdd: null,
      endTimeAdd: null,
    }
  },
  watch: {
    startTime: function (newStartTime, oldStartTime) {
      this.calculateMinuteOT();
    },
    endTime: function (newEndTime, oldEndTime) {
      this.calculateMinuteOT();
    }
  },
  mounted() {
    this.userType = this.$store.getters.userType
    this.getDepartment();
    this.getEmployee();
    this.getShiftoption();
    this.getListOverTime()
    this.startDateString = this.getNowDate()
    this.endDateString = this.getNowDate()
    if (this.$store.getters.locale == 'vi') {
      this.configDateTimePicker.locale = FlatpickrLanguages["vn"]
    };
  },
  methods: {
        checkPermission(id) {
      if (this.$store.getters.fullName.includes("ADMIN")) {
        return true
      }
      return this.$store.getters.permissions.includes(id);
    },
    calculateMinuteOT: function () {
      if (this.startTime && this.endTime) {
        const startMoment = moment(this.startTime, "HH:mm");
        const endMoment = moment(this.endTime, "HH:mm");
        let minuteOT = endMoment.diff(startMoment, "minutes");
        minuteOT = Math.max(0, minuteOT);
        this.minuteOT = minuteOT;
      }
    },
    calculateMinuteOTAdd(start, end) {
      if (start && end) {
        const startMoment = moment(start, "HH:mm");
        const endMoment = moment(end, "HH:mm");
        let minuteOT = endMoment.diff(startMoment, "minutes");
        minuteOT = Math.max(0, minuteOT);
        return minuteOT
      }
    },
    hideModalInfoDetail() {
      this.$refs["modal-info-detail"].hide();
    },
    hideModalDelete() {
      this.$refs["modal-delete"].hide();
    },
    showDelete(id) {
      this.idDelete = id
      console.log();
      this.modalDelete = true
    },
    async deleteOvertime() {
      let res;
      try {
        res = await apiServer.post("/api/v1/overtime/delete", {
          id: this.idDelete,
        });
        if (res && res.data) {
          this.modalDelete = false;
          this.$notify({
            group: "bottomnotification",
            title: this.$t("label.notification"),
            text: this.$t(res.data.message),
            position: "bottom-center",
          });
          await this.getListOverTime();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async showInfoDetail(item) {
      this.dateSelect = moment(item.dateOT).format("DD/MM/YYYY");
      console.log(this.dateSelect);
      this.idPerson = item.fullName
      this.minuteOT = item.minute_ot;
      this.reasonForOT = item.reason;
      this.shiftId = null;
      this.startTime = item.startTime
      this.overtimeId = item?.id
      this.endTime = item.endTime
      this.modalInfoDetail = true;
    },
    async editOvertime() {
      let res;
      let user_id =
        this.idPerson != null && this.idPerson != ""
          ? this.idPerson.value
          : null;

      this.loading = true;
      try {
        res = await apiServer.post("/api/v1/overtime/save", {
          id: this.overtimeId,
          aliasID: user_id,
          minuteOT: this.minuteOT,
          dateOT: this.convertTimestampSendDate(this.dateSelect),
          reason: this.reasonForOT.trim(),
          startTime: this.startTime,
          endTime: this.endTime
        });
        if (res && res.data) {
          if (res.status === 200) {
            this.modalAddOvertime = false;
            this.modalInfoDetail = false;
            this.$notify({
              group: "bottomnotification",
              title: this.$t("label.notification"),
              text: this.$t(res.data.message),
              position: "bottom-center",
            });
            await this.getListOverTime();
          }
        }
      } catch (error) {
        this.loading = false;
        if (error.response.status === 400) {
          this.msg = error.response.data;
        }
        if (error.response.data["message"]) {
          this.$notify({
            group: "bottomnotification",
            title: this.$t("label.notificationError"),
            text: this.$t(this.msg["message"]),
            type: "error",
          });
        }
      }
    },
    async getDepartment() {
      let res
      try {
        res = await apiServer.post('api/v1/department/list', {})
      } catch (error) { }
      if (res && res.data) {
        this.departmentOption = res.data;
      }
    },
    selectAll() {
      if (this.allSelected == true) {
        this.userSelected = this.dataTable.map((x) => x.aliasID);
      } else {
        this.userSelected = [];
      }
    },
    async getShiftoption() {
      let res
      try {
        res = await apiServer.post('/api/v1/shifts/get', {})
      } catch (error) { }
      if (res && res.data) {
        this.shiftsOptions = res.data;
      }
    },
    getNowDate() {
      let today = new Date()
      const dd = String(today.getDate()).padStart(2, '0')
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const yyyy = today.getFullYear()
      today = dd + '/' + mm + '/' + yyyy
      return today
    },
    getTomorrowDate() {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const dd = String(tomorrow.getDate()).padStart(2, '0');
      const mm = String(tomorrow.getMonth() + 1).padStart(2, '0');
      const yyyy = tomorrow.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    },
    convertTimestampSendDate(date) {
      if (date == undefined || date == null || date == '') {
        return null;
      }
      const dateString = date;
      const changedDate = dateString.replace(/(..)\/(..)\/(....)/, "$3-$2-$1");
      var date = new Date(changedDate);
      return moment(date).format("yyyy-MM-DD");
    },
    handleHeaderClick(column) {
      this.clickedColumn = column;
      console.log('Bạn đã click vào header của cột:', column);
      // Thực hiện các thao tác khi click vào header của cột tương ứng
    },
    handleHeaderClickDetails(column) {
      this.clickedColumn = column;
      console.log('Bạn đã click vào header của cột:', column);
      // Thực hiện các thao tác khi click vào header của cột tương ứng
    },
    async getEmployee() {
      this.loading = true;
      let placeID = this.$store.getters.placeID;
      let dpid = (this.departmentid != null && this.departmentid != undefined) ?
        [this.departmentid] : null;
      this.dataTable = [];
      let res
      try {
        res = await apiServer.post('api/v1/user/get-list-user', {
          placeID: placeID,
          aliasID: this.aliasId,
          userName: this.userName,
          department: dpid,
          currentPage: this.currentPage,
          rowPerPage: this.perPage,
          hadAShift: this.shiftid
        })
      } catch (error) {
        this.loading = false;
      }
      if (res && res.data) {
        this.dataTable = res.data.data.results;
        this.totalRecord = res.data.data.totalRecord;
        this.loading = false;
      }
    },
    async addOvertime() {

      if (this.startTimeAdd == null || this.endTimeAdd == null) {
        this.$notify({
          group: "bottomnotification",
          title: this.$t("label.notification"),
          text: "Bạn chưa chọn giờ",
          type: 'error',
          position: "bottom-center",
        });
        return false;
      }
      console.log(this.userSelected);
      if (this.userSelected.length == 0 || this.userSelected == undefined) {
        this.$notify({
          group: "bottomnotification",
          title: this.$t("label.notification"),
          text: "Chưa có nhân viên được chọn",
          type: 'error',
          position: "bottom-center",
        });
        return false;
      }
      if (this.reasonForOTAdd == '' || this.endTimeAdd == null) {
        this.$notify({
          group: "bottomnotification",
          title: this.$t("label.notification"),
          text: "Bạn cần nhập lý do",
          type: 'error',
          position: "bottom-center",
        });
        return false;
      }
      let res;
      try {
        res = await apiServer.post("api/v1/overtime/save", {
          dateOT: this.convertTimestampSendDate(this.startDateString),
          reason: this.reasonForOTAdd.trim(),
          aliasIDs: this.userSelected,
          startTime: this.startTimeAdd,
          endTime: this.endTimeAdd,
          minuteOT: this.calculateMinuteOTAdd(this.startTimeAdd, this.endTimeAdd),
          id: null
        });
      } catch (error) {
        if (error.response.data.message) {
          this.$notify({
            group: 'bottomnotification',
            title: this.$t('label.notificationError'),
            text: this.$t(error.response.data.message),
            type: 'error',
            position: 'bottom-center'
          });
        }
      }
      if (res && res.data) {
        this.userSelected = false;
        this.userSelected = [];
        this.dateSelect = ''
        this.startTime = null
        this.endTime = null
        this.minuteOT = null
        await this.getListOverTime();
        this.$notify({
          group: "bottomnotification",
          title: this.$t("label.notification"),
          text: this.$t(res.data.message),
          position: "bottom-center",
        });
      }

    },
    async getListOverTime() {
      this.dataTableOverTime = [];
      let res
      try {
        res = await apiServer.post('api/v1/overtime/get-list', {
          currentPage: this.currentPageOverTime,
          perPage: this.perPageOverTime,
          dateOT: this.convertTimestampSendDate(this.dateSelectSearch),
          departmentId: this.departmentid,
          aliasID: this.aliasId,
          aliasIDRow: this.employeeId,


        })
      } catch (error) { }
      if (res && res.data) {
        this.dataTableOverTime = res.data.data.result;
        this.totalRecordOT = res.data.data.totalRecords;
      }
    },
    handleClickOutside() {
      this.isOpenNameRes = false;
    },
    async onChangeName() {
      this.employeeId = null
      this.nameEmployee = ''
      this.isOpenNameRes = true;
      let res;
      try {
        res = await apiServer.post('api/v1/user/suggest-employee', {
          placeID: this.$store.getters.placeID,
          keyword: this.fullName,
          searchType: "name"
        })
      } catch (error) {
      }
      if (res && res.data) {
        this.nameResults = [];
        if (res.data.length > 0) {
          for (let user of res.data) {
            this.nameResults.push({ value: user.aliasID, text: user.fullName });
          }
        }
      }
    },
    setNameResult(result) {
      this.aliasId = result.value;
      this.fullName = result.text;
      this.isOpenNameRes = false;
      this.employeeId = null
      this.nameEmployee = ''
      setTimeout(() => { this.getEmployee(), this.getListOverTime() }, 500);
    },
    changeDepartment() {
      this.employeeId = null
      this.nameEmployee = ''
      setTimeout(() => { this.getEmployee(), this.getListOverTime() }, 500);
    },
    convertDate(inputDate) {
      if (inputDate == '' || inputDate == null) return;
      return moment(inputDate).format("DD/MM/yyyy HH:mm:ss");
    },
    rowClickHandler(record, index) {
      this.nameEmployee = record.fullName
      this.employeeId = record.aliasID
      this.getListOverTime(this.employeeId);
    }
  }
}
</script>